<template functional>
  <div
    v-bind="data.attrs"
    :class="['Tag', data.class, data.staticClass]"
    v-on="listeners">
    <slot />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.Tag {
  background: $main;
  border-radius: $radius;
  color: $white;
  display: inline-block;
  font-size: $h6;
  font-weight: $semibold;
  line-height: 1.75rem;
  padding: 0 0.5rem;
  text-align: center;

  // > .dot {
  //   background: $main;
  //   border-radius: $radius-round;
  //   display: inline-block;
  //   height: 0.5rem;
  //   margin-right: 0.25rem;
  //   width: 0.5rem;
  // }

  // size
  // &.xs {
  //   font-size: $h7;
  //   line-height: 0.9rem;
  //   padding: 0 0.25rem;
  // }
  &.sm {
    font-size: $h6;
    line-height: 1rem;
    padding: 0.25rem 0.5rem;
  }
  // &.lg {
  //   font-size: $h5;
  //   > .dot {
  //     height: 0.75rem;
  //     width: 0.75rem;
  //   }
  // }

  // theme
  &.inv {
    background: transparent;
    border: 1px solid $main;
    color: $main;
  }

  &.danger {
    background: $danger;
  }

  &.info {
    background: $info;
  }

  &.success {
    background: $success;
  }

  // shape
  &.round {
    border-radius: $radius-round;
    height: 1.5rem;
    line-height: 1.5rem;
    width: 1.5rem;
  }
}
</style>
